
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  platformUrl: 'http://ec.europa.eu/consumers/odr',
  data () {
    return {
      title: this.$t('links.imprint')
    }
  },
  nuxtI18n: {
    paths: {
      de: '/impressum',
      en: '/imprint',
      nl: '/afdruk',
      da: '/aftryk',
      es: '/imprimir',
      cs: '/otisk',
      pl: '/odcisk'

    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        {
          name: 'robots',
          content: 'noindex'
        }
      ]
    }
  },
  computed: {
    ...mapState('customer', ['customer']),
    ...mapGetters({ isNlDomain: 'isNlDomain' }),

    serviceEmail () {
      if (this.isNlDomain) {
        return 'service@caravanmarkt24.nl'
      } else {
        return 'service@caravanmarkt24.de'
      }
    }

  },
  mounted () {
    this.collect({
      action: 'view'
    })
  },
  methods: {
    ...mapActions('useractionlog', ['collect'])
  }
}
